import ThemeOptions from "./ThemeOptions";
import TestReducer from "../Mathsolutely/Reducers/TestReducer";

export default {
  ThemeOptions,
  TestReducer,
};
